/* A Leading Role — Curtain Call theme JS (Shopify AJAX cart). */
(function(){
'use strict';
/* how long "No thanks" hides the welcome popup before it's allowed to reappear */
var WELCOME_DISMISS_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000; // 3 days
/* ---- real customer order data ----
   Rendered server-side by Shopify's own request-time customer session (the JSON
   script tag alr-footer.liquid emits — see #c-customer-data) — the same auth that
   powers /account, automatically scoped to whoever is actually signed in. Never the
   Admin API, never a credential of any kind in this file. Guests simply get
   logged_in:false and no order history. */
var CUSTOMER_DATA = { logged_in: false, id: null, first_name: null, login_url: null, orders: [] };
(function(){
  var el = document.getElementById('c-customer-data');
  if(!el) return;
  try{ var parsed = JSON.parse(el.textContent); if(parsed) CUSTOMER_DATA = parsed; }catch(err){}
})();
function esc(str){
  return String(str == null ? '' : str).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];
  });
}
/* ---- Rep AI concierge bridge ----
   window.rep is the stub/API defined by the bootstrap snippet in theme.liquid <head>.
   We queue a 'load' listener: once Rep's real widget script finishes initializing
   (whenever that happens), we hide Rep's own default launcher bubble (so only our
   branded button shows) and color-match its chat window to the site's palette. */
var repReady = false;
if(window.rep && typeof window.rep.on === 'function'){
  window.rep.on('load', function(){
    repReady = true;
    try{ window.rep.hide(); }catch(err){}
    try{ window.rep.config({ mainColor: '#6d1a26' }); }catch(err){}
  });
}
function repOpen(){
  if(repReady && window.rep && typeof window.rep.open === 'function'){
    try{ window.rep.open(); return true; }catch(err){ return false; }
  }
  return false;
}
/* Rep's own chat window sometimes initializes (repReady=true, open() doesn't throw)
   but renders nothing visible — its container stays 0x0 until fully provisioned on
   Rep's side. Rather than leave the customer clicking a button that does nothing,
   check shortly after opening whether Rep actually drew anything on screen; if not,
   fall back to the branded canned-response panel so the button always does something. */
function repVisibleAfterOpen(){
  var rc = document.getElementById('repWebClientContainer');
  if(!rc) return false;
  var r = rc.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
}
function openConciergePanel(){
  var c = document.getElementById('concierge');
  document.getElementById('concierge-btn').style.display = 'none';
  var bt = document.getElementById('back-top'); if(bt) bt.style.visibility = 'hidden';
  c.classList.add('open');
  cSetOpenFlag(true);
  if(!c._greeted){ c._greeted = true;
    var restored = cRestoreHistory();
    if(!restored){
      if(CUSTOMER_DATA.logged_in){
        cMsg('Welcome back' + (CUSTOMER_DATA.first_name ? ', ' + esc(CUSTOMER_DATA.first_name) : '') + ' &#10022; I&rsquo;m your Concierge. Ask me about your orders, sizing, shipping, returns, or any piece in the collection.');
      } else {
        cMsg('Welcome to A Leading Role &#10022; I&rsquo;m your Concierge. How can I help you step into the spotlight today?');
        cMsg('I can help with general questions on sizing, shipping, returns, and products right away. <a href="#" data-modal="account">Sign in or create an account</a> and I can also pull up your real order status.');
      }
    }
  }
  /* Skip auto-focus on mobile: focusing the input immediately pops the on-screen
     keyboard, which resizes the browser's visual viewport out from under this
     fixed-position, top:50%-centered panel — on a real phone that reads as the
     popup (and the page behind it) suddenly jumping/off-center the moment it
     opens. Desktop has no virtual keyboard, so it keeps the original auto-focus
     exactly as before; the visitor can still tap the field on mobile to type. */
  cRestoreDraft();
  if(!isMobileNav()){
    var inp = document.getElementById('c-input'); if(inp) inp.focus();
  }
}
function money(cents){
  return '$' + (cents/100).toFixed(2);
}
function lockScroll(){
  var y = window.scrollY || window.pageYOffset || 0;
  document.body.style.top = (-y) + 'px';
  document.body.classList.add('modal-open');
}
function unlockScroll(){
  var y = document.body.style.top;
  document.body.classList.remove('modal-open');
  document.body.style.top = '';
  if(y){ window.scrollTo({ top: parseInt(y || '0', 10) * -1, left: 0, behavior: 'instant' }); }
}
function toast(msg){
  var t = document.getElementById('toast'); if(!t) return;
  t.innerHTML = msg || 'Added to your bag &nbsp;&#10022;';
  t.classList.add('show');
  clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('show'); }, 1800);
}
function updateBadge(count){
  var b = document.getElementById('bag-count');
  if(b){ b.textContent = count; b.classList.toggle('show', count > 0); }
}
function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }
function addVariant(variantId, qty){
  return fetch('/cart/add.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: variantId, quantity: qty || 1})
  }).then(function(r){
    if(!r.ok) throw new Error('add failed');
    return fetchCart();
  }).then(function(cart){
    updateBadge(cart.item_count); toast(); openBagDrawer(cart);
    return cart;
  }).catch(function(){ toast('Could not add &mdash; please try the product page'); });
}
function changeLine(line, qty){
  return fetch('/cart/change.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({line: line, quantity: qty})
  }).then(function(r){ return r.json(); }).then(function(cart){
    updateBadge(cart.item_count);
    renderBag(cart);
    if(document.querySelector('.cart-lines') && !document.getElementById('mbag-root').closest('dialog[open]')){
      window.location.reload();
    }
    return cart;
  });
}
/* ---- free-shipping progress bar (cart drawer) ----
   Threshold matches the site's existing "Free shipping on orders over $99" copy
   (Shipping & Delivery accordion, footer trust badges, FAQ, empty-cart state) —
   kept as one constant here so it only needs updating in one place if that ever
   changes. cart.total_price is Shopify's cart total in cents. */
var FREE_SHIPPING_THRESHOLD_CENTS = 9900;
function shipBarHtml(totalCents){
  var remaining = FREE_SHIPPING_THRESHOLD_CENTS - totalCents;
  if(remaining <= 0){
    return '<div class="cart-shipbar unlocked"><div class="csb-msg">&#10022; You&rsquo;ve unlocked Free Shipping!</div><div class="csb-track"><div class="csb-fill" style="width:100%;"></div></div></div>';
  }
  var pct = Math.max(0, Math.min(100, (totalCents / FREE_SHIPPING_THRESHOLD_CENTS) * 100));
  return '<div class="cart-shipbar"><div class="csb-msg">You&rsquo;re <strong>' + money(remaining) + '</strong> away from Free Shipping!</div><div class="csb-track"><div class="csb-fill" style="width:' + pct + '%;"></div></div></div>';
}
/* ---- bag modal ---- */
/* ---- cart drawer "You May Also Like" (4 items) ----
   Seeded from Shopify's own /recommendations/products.json for the first line
   item in the cart (the same public, unauthenticated endpoint Dawn-family themes
   use for product-page recommendations), topped up from the Best Sellers
   collection if that returns fewer than 4 usable items. Cached per seed product
   for the life of the page so re-opening/re-rendering the drawer (e.g. after a
   qty change) doesn't refetch. Items already in the cart are filtered out. */
var CART_RECS_CACHE = {};
function cartRecsHtml(items){
  return '<div class="cart-recs-head">You May Also Like</div>' +
    '<div class="cart-recs-grid">' + items.map(function(p){
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var variants = p.variants || [];
      var variant = variants.filter(function(v){ return v.available; })[0] || variants[0];
      var price = variant ? variant.price : p.price;
      return '<div class="cart-rec">' +
        '<a href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' +
        '<a class="n" href="' + p.url + '">' + esc(p.title) + '</a>' +
        '<div class="p">' + money(price) + '</div>' +
        (variant ? '<button type="button" class="add" data-crec-vid="' + variant.id + '">Add</button>' : '') +
        '</div>';
    }).join('') + '</div>';
}
function renderCartRecs(cart){
  var slot = document.getElementById('mbag-recs');
  if(!slot || !cart || !cart.items.length) return;
  var inCart = {};
  cart.items.forEach(function(it){ inCart[it.product_id] = true; });
  var seedId = cart.items[0].product_id;
  var apply = function(list){
    var filtered = (list || []).filter(function(p){ return !inCart[p.id]; }).slice(0, 4);
    slot.innerHTML = filtered.length ? cartRecsHtml(filtered) : '';
  };
  if(CART_RECS_CACHE[seedId]){ apply(CART_RECS_CACHE[seedId]); return; }
  fetch('/recommendations/products.json?product_id=' + seedId + '&limit=8&intent=related')
    .then(function(r){ return r.ok ? r.json() : {products:[]}; })
    .then(function(data){
      var list = (data && data.products) || [];
      if(list.length < 4){
        return fetch('/collections/best-sellers/products.json?limit=12')
          .then(function(r){ return r.ok ? r.json() : {products:[]}; })
          .then(function(d2){
            var seen = {}; list.forEach(function(p){ seen[p.id] = true; });
            ((d2 && d2.products) || []).forEach(function(p){ if(!seen[p.id]){ list.push(p); seen[p.id] = true; } });
            return list;
          });
      }
      return list;
    })
    .then(function(list){ CART_RECS_CACHE[seedId] = list; apply(list); })
    .catch(function(){ /* recs are a nice-to-have — fail quietly, keep the rest of the drawer working */ });
}
function renderBag(cart){
  var root = document.getElementById('mbag-root'); if(!root) return;
  var render = function(c){
    if(!c.items.length){
      var tpl = document.getElementById('cart-empty-tpl');
      root.innerHTML = tpl ? tpl.innerHTML : '<p>Your bag is empty.</p>';
      return;
    }
    var rows = c.items.map(function(it, i){
      return '<div class="cart-line">' +
        '<a href="' + it.url + '"><img src="' + (it.image || '') + '" alt=""></a>' +
        '<div><a class="n" href="' + it.url + '">' + it.product_title + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="s">' + it.variant_title + '</div>' : '') + '</div>' +
        '<div class="qty"><button data-mline="' + (i+1) + '" data-mq="-1">&ndash;</button><span>' + it.quantity + '</span><button data-mline="' + (i+1) + '" data-mq="1">+</button></div>' +
        '<button class="rm" data-mline-rm="' + (i+1) + '">Remove</button>' +
        '</div>';
    }).join('');
    root.innerHTML = shipBarHtml(c.total_price) + '<div class="cart-lines">' + rows + '</div>' +
      '<div class="cart-total"><span class="t">Subtotal</span><span class="v">' + money(c.total_price) + '</span></div>' +
      '<div class="modal-actions"><button type="button" class="btn" id="mbag-keep-shopping">Keep Shopping</button><a class="btn gold" href="/checkout" id="mbag-checkout">Checkout</a></div>' +
      '<div class="cart-recs" id="mbag-recs"></div>';
    renderCartRecs(c);
  };
  if(cart){ render(cart); } else { fetchCart().then(render); }
}
/* ---- cart drawer (slides in from the right) ---- */
function openBagDrawer(cart){
  renderBag(cart);
  var d = document.getElementById('modal-bag');
  if(!d) return;
  if(d.hasAttribute('open')){ d.classList.add('show'); return; }
  lockScroll();
  d.showModal();
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){ d.classList.add('show'); });
  });
}
function closeCartDrawer(){
  var d = document.getElementById('modal-bag');
  if(!d || !d.hasAttribute('open')) return;
  d.classList.remove('show');
  var done = false;
  function finish(){ if(done) return; done = true; d.close(); }
  d.addEventListener('transitionend', finish, {once:true});
  setTimeout(finish, 360);
}
/* ---- mobile hamburger nav ---- */
function openMobileNav(){
  var nav = document.getElementById('mobile-nav');
  var bd = document.getElementById('mobile-nav-backdrop');
  var toggle = document.getElementById('nav-toggle');
  if(!nav) return;
  lockScroll();
  nav.classList.add('show'); nav.setAttribute('aria-hidden', 'false');
  if(bd) bd.classList.add('show');
  if(toggle) toggle.setAttribute('aria-expanded', 'true');
}
function closeMobileNav(){
  var nav = document.getElementById('mobile-nav');
  var bd = document.getElementById('mobile-nav-backdrop');
  var toggle = document.getElementById('nav-toggle');
  if(!nav || !nav.classList.contains('show')) return;
  unlockScroll();
  nav.classList.remove('show'); nav.setAttribute('aria-hidden', 'true');
  if(bd) bd.classList.remove('show');
  if(toggle) toggle.setAttribute('aria-expanded', 'false');
}
/* ---- variant quick-add ---- */
function openVariant(btn){
  var variants = JSON.parse(btn.getAttribute('data-variants') || '[]');
  var titles = JSON.parse(btn.getAttribute('data-vtitles') || '[]');
  var availables = JSON.parse(btn.getAttribute('data-availables') || '[]');
  var firstOk = 0;
  for(var i=0;i<variants.length;i++){ if(availables[i] !== false){ firstOk = i; break; } }
  var body = document.getElementById('variant-body');
  if(!body){ if(availables[0] !== false) addVariant(variants[0]); return; }
  var sizesHtml = '';
  if(variants.length > 1){
    sizesHtml = '<div class="opt-label" style="margin-top:8px;">Option</div>' +
      '<div class="sizes" id="vsizes">' + titles.map(function(t, i){
        var soldOut = availables[i] === false;
        var cls = (i===firstOk ? 'on' : '') + (soldOut ? ' soldout' : '');
        return '<button type="button" data-vid="' + variants[i] + '"' +
          (cls.trim() ? ' class="' + cls.trim() + '"' : '') +
          (soldOut ? ' disabled aria-disabled="true"' : '') +
          '>' + t + (soldOut ? ' <span class="vso">Sold Out</span>' : '') + '</button>';
      }).join('') + '</div>';
  }
  var singleSoldOut = variants.length === 1 && availables[0] === false;
  body.innerHTML = '<div class="vname">' + btn.getAttribute('data-title') + '</div>' +
    '<div class="vprice">' + btn.getAttribute('data-price') + '</div>' +
    sizesHtml +
    '<div class="modal-actions"><button class="btn gold" id="vadd" data-single-vid="' + variants[firstOk] + '"' +
    (singleSoldOut ? ' disabled' : '') + '>' + (singleSoldOut ? 'Sold Out' : 'Add to Bag') + '</button></div>';
  lockScroll();
  document.getElementById('modal-variant').showModal();
}
/* Quick add from the live search modal: /search/suggest.json never returns real
   variant data (confirmed empirically — its product objects always report an empty
   variants array), so the "+" button on a search result fetches the real product via
   the safe public /products/{handle}.js endpoint on click, then reuses the same
   size-picker modal as every other quick-add button on the site. */
function openVariantFromProduct(product){
  var variants = product.variants || [];
  if(!variants.length){ toast('Could not load that item &mdash; please open the product page'); return; }
  var ids = variants.map(function(v){ return v.id; });
  var titles = variants.map(function(v){ return v.title; });
  var availables = variants.map(function(v){ return v.available; });
  var firstOk = 0;
  for(var i=0;i<ids.length;i++){ if(availables[i] !== false){ firstOk = i; break; } }
  var body = document.getElementById('variant-body');
  if(!body){ if(availables[0] !== false) addVariant(ids[0]); return; }
  var sizesHtml = '';
  if(ids.length > 1){
    sizesHtml = '<div class="opt-label" style="margin-top:8px;">Option</div>' +
      '<div class="sizes" id="vsizes">' + titles.map(function(t, i){
        var soldOut = availables[i] === false;
        var cls = (i===firstOk ? 'on' : '') + (soldOut ? ' soldout' : '');
        return '<button type="button" data-vid="' + ids[i] + '"' +
          (cls.trim() ? ' class="' + cls.trim() + '"' : '') +
          (soldOut ? ' disabled aria-disabled="true"' : '') +
          '>' + esc(t) + (soldOut ? ' <span class="vso">Sold Out</span>' : '') + '</button>';
      }).join('') + '</div>';
  }
  var singleSoldOut = ids.length === 1 && availables[0] === false;
  var displayPrice = variants[firstOk] ? variants[firstOk].price : product.price;
  body.innerHTML = '<div class="vname">' + esc(product.title) + '</div>' +
    '<div class="vprice">' + money(displayPrice) + '</div>' +
    sizesHtml +
    '<div class="modal-actions"><button class="btn gold" id="vadd" data-single-vid="' + ids[firstOk] + '"' +
    (singleSoldOut ? ' disabled' : '') + '>' + (singleSoldOut ? 'Sold Out' : 'Add to Bag') + '</button></div>';
  lockScroll();
  document.getElementById('modal-variant').showModal();
}
function quickAddSearchResult(handle, btn){
  var original = btn ? btn.textContent : '';
  if(btn){ btn.disabled = true; btn.textContent = '…'; }
  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function(r){ if(!r.ok) throw new Error('not found'); return r.json(); })
    .then(function(product){
      if(btn){ btn.disabled = false; btn.textContent = original || '+'; }
      openVariantFromProduct(product);
    })
    .catch(function(){
      if(btn){ btn.disabled = false; btn.textContent = original || '+'; }
      toast('Could not load that item &mdash; please open the product page');
    });
}
/* ---- wishlist ----
   Login-gated, per-account, stored in this browser's localStorage (no backend write —
   a true cross-device wishlist would require writing to customer data server-side,
   which is out of scope here). Keyed by the real Shopify customer id from CUSTOMER_DATA
   (see #c-customer-data in alr-footer.liquid) so each signed-in shopper gets their own
   list on this device; signed-out visitors are sent to sign in / create an account
   instead of silently wishlisting to an anonymous bucket. Stores product HANDLES (not
   numeric ids) and resolves them via the same safe public /products/{handle}.js
   endpoint quickAddSearchResult() already uses above. */
function wlStorageKey(){
  if(!CUSTOMER_DATA.logged_in || !CUSTOMER_DATA.id) return null;
  return 'alr_wishlist_' + CUSTOMER_DATA.id;
}
function getWishlist(){
  var key = wlStorageKey(); if(!key) return [];
  try{
    var raw = localStorage.getItem(key);
    var arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  }catch(err){ return []; }
}
function saveWishlist(arr){
  var key = wlStorageKey(); if(!key) return;
  try{ localStorage.setItem(key, JSON.stringify(arr)); }catch(err){}
}
function isWished(handle){
  return getWishlist().indexOf(handle) !== -1;
}
function toggleWish(handle){
  var list = getWishlist();
  var i = list.indexOf(handle);
  if(i === -1){ list.push(handle); } else { list.splice(i, 1); }
  saveWishlist(list);
  syncWishlistUI();
  return i === -1;
}
/* refresh every heart button + the header badge to match current stored state */
function syncWishlistUI(){
  var list = CUSTOMER_DATA.logged_in ? getWishlist() : [];
  document.querySelectorAll('.wlbtn[data-wl]').forEach(function(btn){
    var on = list.indexOf(btn.getAttribute('data-wl')) !== -1;
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  var count = document.getElementById('wl-count');
  if(count){
    count.textContent = list.length;
    count.classList.toggle('show', list.length > 0);
  }
}
function renderWishlistCard(p){
  var img = (p.featured_image || (p.images && p.images[0])) || '';
  var soldOut = !p.available;
  var tag = soldOut ? '<span class="prod-tag prod-tag-soldout">Sold Out</span>' : '';
  var qaddBtn = (!soldOut && p.handle)
    ? '<button type="button" class="qadd" aria-label="Quick add to bag" title="Quick add" data-search-handle="' + esc(p.handle) + '">+</button>'
    : '';
  return '<div class="prod-card wl-card' + (soldOut ? ' sold-out' : '') + '">' +
    '<a href="' + esc(p.url) + '"><div class="prod-thumb">' +
    (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + tag + qaddBtn +
    '</div></a>' +
    '<button type="button" class="wlbtn on wl-remove" aria-label="Remove from wishlist" data-wl="' + esc(p.handle) + '"><svg viewBox="0 0 24 24" stroke-width="1.8"><path d="M12 20.5s-7.5-4.6-9.7-9.1C.7 8 2.1 4.5 5.5 3.7c2.1-.5 4 .4 6.5 3 2.5-2.6 4.4-3.5 6.5-3 3.4.8 4.8 4.3 3.2 7.7-2.2 4.5-9.7 9.1-9.7 9.1z"/></svg></button>' +
    '<a href="' + esc(p.url) + '"><div class="prod-name">' + esc(p.title) + '</div>' +
    '<div class="prod-price">' + money(p.price) + '</div></a>' +
    '</div>';
}
function renderWishlistModal(){
  var root = document.getElementById('wl-root'); if(!root) return;
  if(!CUSTOMER_DATA.logged_in){
    var signinTpl = document.getElementById('wishlist-signin-tpl');
    root.innerHTML = signinTpl ? signinTpl.innerHTML : '<p>Please sign in.</p>';
    return;
  }
  var handles = getWishlist();
  if(!handles.length){
    var emptyTpl = document.getElementById('wishlist-empty-tpl');
    root.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<p>Your wishlist is empty.</p>';
    return;
  }
  root.innerHTML = '<div class="prod-grid four" id="wl-grid">Loading&hellip;</div>';
  Promise.all(handles.map(function(handle){
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; });
  })).then(function(products){
    var found = products.filter(Boolean);
    if(!found.length){
      var emptyTpl2 = document.getElementById('wishlist-empty-tpl');
      root.innerHTML = emptyTpl2 ? emptyTpl2.innerHTML : '<p>Your wishlist is empty.</p>';
      return;
    }
    /* drop any handle that no longer resolves to a real product (deleted/unpublished) */
    if(found.length !== handles.length){ saveWishlist(found.map(function(p){ return p.handle; })); }
    var grid = document.getElementById('wl-grid');
    if(grid) grid.outerHTML = '<div class="prod-grid four" id="wl-grid">' + found.map(renderWishlistCard).join('') + '</div>';
  });
}
function openWishlistModal(){
  var d = document.getElementById('modal-wishlist');
  if(!d) return;
  lockScroll();
  d.showModal();
  renderWishlistModal();
}
/* ---- account sign-in popup ----
   This store runs Shopify's New Customer Accounts, which handles sign-in via an OAuth
   redirect to a separate hosted domain (account.<shop>.com). That page can't be framed
   into an in-page modal (Shopify blocks it for security) and no longer accepts a plain
   email/password form post, so a true "stays on this page" login modal isn't possible.
   The next best thing: open the real, secure Shopify sign-in flow in a small popup
   browser window instead of navigating this tab away. We poll the popup — once it
   either closes or (having finished the OAuth handshake) lands back on our own storefront
   domain, we close it if needed and reload this page so the header picks up the signed-in
   state. Reading popup.location while it's still on the cross-origin accounts domain
   throws, which is exactly how we tell "still signing in" apart from "back on our site".

   Round 2 on mobile: previously this skipped straight to a full-page redirect on
   phones/tablets, on the theory that window.open() is unreliable there (some mobile
   browsers ignore the small-window sizing and force a full-screen tab, or silently do
   nothing). [stated] user explicitly asked to try the real floating popup on mobile too,
   understanding that trade-off, rather than keep the redirect — so mobile now attempts
   the same window.open() as desktop. The existing "popup blocked/unsupported" fallback
   below already redirects if window.open() returns null, so a phone that refuses the
   popup outright still lands on a working sign-in page either way; it just no longer
   skips the attempt up front. Desktop behavior is unchanged. */
function isMobileNav(){
  try{ return window.matchMedia('(max-width:960px)').matches; }catch(err){ return false; }
}
var acctPopupPoll = null;
function openAccountPopup(url){
  var w = 480, h = 640;
  var left = (window.screenX || window.screenLeft || 0) + Math.max(0, ((window.outerWidth || screen.width) - w) / 2);
  var top = (window.screenY || window.screenTop || 0) + Math.max(0, ((window.outerHeight || screen.height) - h) / 2);
  var popup = null;
  try{
    popup = window.open(url, 'alr_account_login', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes');
  }catch(err){ popup = null; }
  if(!popup){
    /* popup blocked (or unsupported) — fall back to the original full-page redirect so
       sign-in still works for every visitor */
    try{ sessionStorage.setItem('alr_pending_login_return', '1'); }catch(err){}
    window.location.href = url;
    return;
  }
  try{ popup.focus(); }catch(err){}
  if(acctPopupPoll) clearInterval(acctPopupPoll);
  acctPopupPoll = setInterval(function(){
    var done = false;
    try{
      if(popup.closed){
        done = true;
      } else if(popup.location && popup.location.hostname === window.location.hostname){
        done = true;
        try{ popup.close(); }catch(err){}
      }
    }catch(err){
      /* still on the cross-origin accounts domain — sign-in isn't finished yet */
    }
    if(done){
      clearInterval(acctPopupPoll);
      acctPopupPoll = null;
      try{ sessionStorage.setItem('alr_pending_login_return', '1'); }catch(err){}
      window.location.reload();
    }
  }, 500);
}
/* ---- checkout popup ----
   Same window.open() pattern as the account sign-in popup, so clicking Checkout in the
   cart drawer doesn't navigate this tab away. Unlike sign-in, we don't force-close the
   popup or reload the main tab when it's done — the customer should get to see their
   order confirmation page fully. Instead, once the popup closes we just refresh the
   cart badge/drawer here in the background, so the header count is correct again if
   checkout completed (emptying the cart) while they were away in the popup. */
var checkoutPopupPoll = null;
function openCheckoutPopup(url){
  var w = 500, h = 780;
  var left = (window.screenX || window.screenLeft || 0) + Math.max(0, ((window.outerWidth || screen.width) - w) / 2);
  var top = (window.screenY || window.screenTop || 0) + Math.max(0, ((window.outerHeight || screen.height) - h) / 2);
  var popup = null;
  try{
    popup = window.open(url, 'alr_checkout', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes');
  }catch(err){ popup = null; }
  if(!popup){
    /* popup blocked (or unsupported) — fall back to a normal full-page redirect so
       checkout still works for every visitor */
    window.location.href = url;
    return;
  }
  try{ popup.focus(); }catch(err){}
  if(checkoutPopupPoll) clearInterval(checkoutPopupPoll);
  checkoutPopupPoll = setInterval(function(){
    if(popup.closed){
      clearInterval(checkoutPopupPoll);
      checkoutPopupPoll = null;
      fetchCart().then(function(cart){ updateBadge(cart.item_count); renderBag(cart); });
    }
  }, 500);
}
/* ---- account view popup (signed-in header account icon) ----
   Same window.open() pattern again, for a signed-in customer clicking the header account
   icon through to their account pages on account.<shop>.com. Unlike account SIGN-IN above,
   there's no OAuth handshake to watch for — the customer is already authenticated and may
   just browse orders/addresses for a while and close the window whenever — so, like the
   checkout popup, we never force-close it or reload the main tab; we just stop polling once
   it's closed. Nothing on this page depends on live account state, so no refresh afterward.

   Round 2 on mobile: same change as the sign-in popup above — [stated] user asked to try
   the real floating popup on mobile too instead of the automatic redirect, so this now
   attempts window.open() on phones/tablets exactly like desktop. The "popup blocked/
   unsupported" fallback below still redirects if window.open() returns null. */
var acctViewPopupPoll = null;
function openAccountViewPopup(url){
  var w = 480, h = 720;
  var left = (window.screenX || window.screenLeft || 0) + Math.max(0, ((window.outerWidth || screen.width) - w) / 2);
  var top = (window.screenY || window.screenTop || 0) + Math.max(0, ((window.outerHeight || screen.height) - h) / 2);
  var popup = null;
  try{
    popup = window.open(url, 'alr_account_view', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes');
  }catch(err){ popup = null; }
  if(!popup){
    /* popup blocked (or unsupported) — fall back to a normal full-page redirect so
       the account link still works for every visitor */
    window.location.href = url;
    return;
  }
  try{ popup.focus(); }catch(err){}
  if(acctViewPopupPoll) clearInterval(acctViewPopupPoll);
  acctViewPopupPoll = setInterval(function(){
    if(popup.closed){
      clearInterval(acctViewPopupPoll);
      acctViewPopupPoll = null;
    }
  }, 500);
}
/* ---- product page variant matching ---- */
function pdSelectedOptions(){
  return Array.prototype.map.call(document.querySelectorAll('.pd-opt'), function(g){
    var on = g.querySelector('button.on');
    return on ? on.getAttribute('data-optval') : null;
  });
}
function pdSyncVariant(){
  var el = document.getElementById('pd-variants'); if(!el) return;
  var variants = JSON.parse(el.textContent);
  var sel = pdSelectedOptions();
  var match = variants.find(function(v){
    return sel.every(function(s, i){ return s === null || v.options[i] === s; });
  });
  var idInput = document.getElementById('pd-variant-id');
  var addBtn = document.getElementById('pd-add');
  if(match && idInput){ idInput.value = match.id; }
  if(addBtn){
    var available = match ? match.available : false;
    addBtn.disabled = !available;
    addBtn.classList.toggle('soldout', !available);
    addBtn.textContent = available ? 'Add to Bag' : (match ? 'Sold Out' : 'Unavailable');
  }
  /* low-stock badge: "Almost Sold Out - X More Left" once tracked inventory is 1-5.
     product.variants | json doesn't include inventory_quantity, so a separate
     #pd-stock map (variant id -> quantity, rendered by the section) supplies it. */
  var lowEl = document.getElementById('pd-lowstock');
  if(lowEl){
    var stockEl = document.getElementById('pd-stock');
    var stock = {};
    if(stockEl){ try{ stock = JSON.parse(stockEl.textContent) || {}; }catch(err){} }
    var qty = match ? stock[String(match.id)] : null;
    var tracked = match ? match.inventory_management === 'shopify' : false;
    var isLow = tracked && typeof qty === 'number' && qty > 0 && qty <= 5;
    lowEl.style.display = isLow ? '' : 'none';
    if(isLow){ lowEl.textContent = 'Almost Sold Out — ' + qty + ' More Left'; }
  }
}
/* gray out size/option buttons that have no available variant behind them */
function pdMarkSoldOutOptions(){
  var el = document.getElementById('pd-variants'); if(!el) return;
  var variants = JSON.parse(el.textContent);
  document.querySelectorAll('.pd-opt').forEach(function(group){
    var idx = parseInt(group.getAttribute('data-opt'), 10);
    group.querySelectorAll('button[data-optval]').forEach(function(btn){
      var val = btn.getAttribute('data-optval');
      var forThisValue = variants.filter(function(v){ return v.options[idx] === val; });
      var anyAvailable = forThisValue.some(function(v){ return v.available; });
      btn.classList.toggle('soldout', !anyAvailable);
    });
  });
}
window.pdSwap = function(btn, src){
  document.getElementById('pd-main').src = src;
  document.querySelectorAll('.pd-thumbs button').forEach(function(b){ b.classList.remove('on'); });
  btn.classList.add('on');
};
window.qty = function(d){
  var el = document.getElementById('q');
  var v = Math.max(1, parseInt(el.textContent) + d);
  el.textContent = v;
  var h = document.getElementById('pd-qty'); if(h) h.value = v;
};
/* ---- global clicks ---- */
document.addEventListener('click', function(e){
  if(e.target.closest('#nav-toggle')){ openMobileNav(); return; }
  if(e.target.closest('#mnav-close') || e.target.closest('#mobile-nav-backdrop')){ closeMobileNav(); return; }
  if(e.target.closest('.mobile-nav a')){ closeMobileNav(); return; }
  var q = e.target.closest('.qadd');
  if(q){
    e.preventDefault(); e.stopPropagation();
    var searchHandle = q.getAttribute('data-search-handle');
    if(searchHandle){ quickAddSearchResult(searchHandle, q); } else { openVariant(q); }
    return;
  }
  var wl = e.target.closest('.wlbtn');
  if(wl){
    e.preventDefault(); e.stopPropagation();
    if(!CUSTOMER_DATA.logged_in){
      openAccountPopup(CUSTOMER_DATA.login_url || '/account/login');
      return;
    }
    var handle = wl.getAttribute('data-wl');
    if(handle) toggleWish(handle);
    if(wl.classList.contains('wl-remove')) renderWishlistModal();
    return;
  }
  /* product-page social icons that can't be deep-linked with a prefilled caption
     (Instagram, TikTok — neither platform offers a website share intent for that):
     copy a ready-made #aleadingrole caption to the clipboard, then open the app/site
     so it can be pasted into a new post. Facebook and Pinterest skip this entirely —
     they use plain hrefs built server-side (see sections/main-product.liquid) since
     both have real official share/pin URLs that don't need JS. */
  var shareCopy = e.target.closest('[data-share-copy]');
  if(shareCopy){
    e.preventDefault(); e.stopPropagation();
    var shareCaption = shareCopy.getAttribute('data-share-copy') || '';
    var shareOpenUrl = shareCopy.getAttribute('data-share-open') || shareCopy.getAttribute('href') || '#';
    var shareLabel = shareCopy.getAttribute('data-share-label') || 'the app';
    var openShareTarget = function(copied){
      toast(copied
        ? 'Caption copied &mdash; paste it into your ' + shareLabel + ' post &#10022;'
        : 'Opening ' + shareLabel + '&hellip; copy your caption from the product page first');
      window.open(shareOpenUrl, '_blank', 'noopener');
    };
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(shareCaption).then(function(){ openShareTarget(true); }).catch(function(){ openShareTarget(false); });
    } else {
      openShareTarget(false);
    }
    return;
  }
  var vs = e.target.closest('#vsizes button');
  if(vs){
    if(vs.hasAttribute('disabled')) return;
    vs.parentElement.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
    vs.classList.add('on'); return;
  }
  var vaddBtn = e.target.closest('#vadd');
  if(vaddBtn){
    if(vaddBtn.hasAttribute('disabled')) return;
    var on = document.querySelector('#vsizes button.on');
    var vid = on ? on.getAttribute('data-vid') : vaddBtn.getAttribute('data-single-vid');
    if(vid) addVariant(parseInt(vid));
    document.getElementById('modal-variant').close(); return;
  }
  var po = e.target.closest('.pd-opt button');
  if(po){
    po.parentElement.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
    po.classList.add('on'); pdSyncVariant(); return;
  }
  var mq = e.target.closest('[data-mq]');
  if(mq){
    var line = parseInt(mq.getAttribute('data-mline'));
    var span = mq.parentElement.querySelector('span');
    var newq = Math.max(0, parseInt(span.textContent) + parseInt(mq.getAttribute('data-mq')));
    changeLine(line, Math.max(1, newq)); return;
  }
  var mr = e.target.closest('[data-mline-rm]');
  if(mr){ changeLine(parseInt(mr.getAttribute('data-mline-rm')), 0); return; }
  var crec = e.target.closest('[data-crec-vid]');
  if(crec){ e.preventDefault(); addVariant(parseInt(crec.getAttribute('data-crec-vid'))); return; }
  var cq = e.target.closest('[data-cq]');
  if(cq){
    var l2 = parseInt(cq.getAttribute('data-line'));
    var s2 = cq.parentElement.querySelector('span');
    changeLine(l2, Math.max(1, parseInt(s2.textContent) + parseInt(cq.getAttribute('data-cq'))))
      .then(function(){ window.location.reload(); });
    return;
  }
  var cr = e.target.closest('[data-line-rm]');
  if(cr){ changeLine(parseInt(cr.getAttribute('data-line-rm')), 0).then(function(){ window.location.reload(); }); return; }
  if(e.target.closest('#mbag-keep-shopping') || e.target.closest('#mbag-close')){ closeCartDrawer(); return; }
  if(e.target.closest('#mbag-checkout')){ e.preventDefault(); openCheckoutPopup('/checkout'); return; }
  var acctLink = e.target.closest('#header-account-link');
  if(acctLink){ e.preventDefault(); openAccountViewPopup(acctLink.getAttribute('href') || '/account'); return; }
  if(e.target.closest('#back-top')){ window.scrollTo({top:0, behavior:'smooth'}); return; }
  if(e.target.closest('#concierge-btn')){
    if(repOpen()){
      setTimeout(function(){ if(!repVisibleAfterOpen()){ openConciergePanel(); } }, 600);
      return;
    }
    openConciergePanel();
    return;
  }
  if(e.target.closest('#c-close')){
    document.getElementById('concierge').classList.remove('open');
    document.getElementById('concierge-btn').style.display = 'flex';
    var bt2 = document.getElementById('back-top'); if(bt2) bt2.style.visibility = '';
    cSetOpenFlag(false);
    return;
  }
  if(e.target.closest('#w-skip')){
    try{ localStorage.setItem('alr_welcome_dismissed_at', String(Date.now())); }catch(err){}
    document.getElementById('modal-welcome').close();
    return;
  }
  if(e.target.closest('#account-show-login')){
    document.getElementById('account-register-view').style.display = 'none';
    document.getElementById('account-login-view').style.display = '';
    document.getElementById('modal-account').querySelector('.p-head h2').textContent = 'Sign In';
    return;
  }
  if(e.target.closest('#account-show-register')){
    document.getElementById('account-login-view').style.display = 'none';
    document.getElementById('account-register-view').style.display = '';
    document.getElementById('modal-account').querySelector('.p-head h2').textContent = 'Create Account';
    return;
  }
  var m = e.target.closest('[data-modal]');
  if(m){
    e.preventDefault();
    var key = m.getAttribute('data-modal');
    if(key === 'account'){
      openAccountPopup(CUSTOMER_DATA.login_url || '/account/login');
      return;
    }
    var open = document.querySelector('dialog[open]');
    if(open) open.close();
    if(key === 'bag'){ openBagDrawer(); return; }
    if(key === 'wishlist'){ openWishlistModal(); return; }
    var d = document.getElementById('modal-' + key);
    if(!d) return;
    lockScroll();
    d.showModal();
    if(key === 'search'){ var si = document.getElementById('msearch-input'); if(si) si.focus({preventScroll:true}); }
  }
});
document.addEventListener('click', function(e){
  if(e.target instanceof HTMLDialogElement && e.target.hasAttribute('open')){
    var r = e.target.getBoundingClientRect();
    if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom){
      if(e.target.id === 'modal-bag'){ closeCartDrawer(); } else { e.target.close(); }
    }
  }
});
document.addEventListener('close', function(e){
  if(e.target && e.target.tagName === 'DIALOG'){ unlockScroll(); }
}, true);
document.addEventListener('cancel', function(e){
  if(e.target && e.target.id === 'modal-bag'){ e.preventDefault(); closeCartDrawer(); }
}, true);
/* ---- concierge ----
   The panel and its conversation both persist for the length of the browser tab's
   session — sessionStorage, cleared when the tab/browser closes, never localStorage,
   so none of this outlives the visit. Signed-in customers get a history key scoped to
   their real Shopify customer id (so a shared device never mixes one account's
   conversation into another's); guests get a single per-tab guest key, which exists
   so the "stay open across pages" behavior below doesn't have to re-greet a guest on
   every page — anonymous, still cleared the moment the tab closes. */
var CONCIERGE_HISTORY_LIMIT = 50;
function cHistoryKey(){
  if(CUSTOMER_DATA.logged_in && CUSTOMER_DATA.id) return 'alr_concierge_history_' + CUSTOMER_DATA.id;
  return 'alr_concierge_history_guest';
}
function cLoadHistory(){
  var key = cHistoryKey(); if(!key) return [];
  try{
    var raw = sessionStorage.getItem(key);
    var arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  }catch(err){ return []; }
}
function cSaveHistory(arr){
  var key = cHistoryKey(); if(!key) return;
  try{
    var trimmed = arr.length > CONCIERGE_HISTORY_LIMIT ? arr.slice(arr.length - CONCIERGE_HISTORY_LIMIT) : arr;
    sessionStorage.setItem(key, JSON.stringify(trimmed));
  }catch(err){}
}
function cRestoreHistory(){
  var hist = cLoadHistory(); if(!hist.length) return false;
  var mel = document.getElementById('c-msgs'); if(!mel) return false;
  hist.forEach(function(m){
    var d = document.createElement('div');
    d.className = 'c-msg ' + (m.who || 'bot');
    d.innerHTML = m.text;
    mel.appendChild(d);
  });
  cStick(mel);
  return true;
}
var CONCIERGE_OPEN_KEY = 'alr_concierge_open';
function cSetOpenFlag(open){
  try{
    if(open){ sessionStorage.setItem(CONCIERGE_OPEN_KEY, '1'); }
    else{ sessionStorage.removeItem(CONCIERGE_OPEN_KEY); }
  }catch(err){}
}
function cWasLeftOpen(){
  try{ return sessionStorage.getItem(CONCIERGE_OPEN_KEY) === '1'; }catch(err){ return false; }
}
/* An unsent draft survives navigation the same way the open panel and the
   conversation do: per-tab sessionStorage, cleared when the tab closes. Without
   this, typing a question and then clicking through to a product page to check
   something loses what you had written. */
var CONCIERGE_DRAFT_KEY = 'alr_concierge_draft';
function cSaveDraft(v){
  try{
    if(v){ sessionStorage.setItem(CONCIERGE_DRAFT_KEY, v); }
    else{ sessionStorage.removeItem(CONCIERGE_DRAFT_KEY); }
  }catch(err){}
}
function cRestoreDraft(){
  var inp = document.getElementById('c-input'); if(!inp) return;
  var d = '';
  try{ d = sessionStorage.getItem(CONCIERGE_DRAFT_KEY) || ''; }catch(err){ d = ''; }
  if(!d || inp.value) return;
  inp.value = d;
  try{ inp.setSelectionRange(d.length, d.length); }catch(err){}
}
document.addEventListener('input', function(e){
  if(e.target && e.target.id === 'c-input'){ cSaveDraft(e.target.value); }
});
/* Product thumbnails have no height yet when a message is appended, so the
   panel would settle above the newest reply and drift further as each image
   loads. Re-pin to the bottom as they arrive. */
function cStick(el){
  var mel = document.getElementById('c-msgs');
  if(mel) mel.scrollTop = mel.scrollHeight;
  var imgs = (el && el.querySelectorAll) ? el.querySelectorAll('img') : [];
  for(var i = 0; i < imgs.length; i++){
    if(imgs[i].complete) continue;
    imgs[i].addEventListener('load', cStick);
    imgs[i].addEventListener('error', cStick);
  }
  setTimeout(function(){ var m = document.getElementById('c-msgs'); if(m) m.scrollTop = m.scrollHeight; }, 150);
}
function cMsg(text, who){
  var mel = document.getElementById('c-msgs'); if(!mel) return;
  var d = document.createElement('div');
  d.className = 'c-msg ' + (who || 'bot');
  d.innerHTML = text;
  mel.appendChild(d); cStick(d);
  var key = cHistoryKey();
  if(key){
    var hist = cLoadHistory();
    /* Flagged so the worker bridge (alr-concierge-live.js), which shares this
       store, knows these entries are HTML and re-renders them as HTML rather
       than as literal text. Its own worker replies carry no flag. */
    hist.push({text: text, who: who || 'bot', html: true});
    cSaveHistory(hist);
  }
}
function cOrderReply(){
  if(!CUSTOMER_DATA.logged_in){
    return 'Sign in and I can pull up your real order status &mdash; <a href="#" data-modal="account">sign in to your account</a>. Already checked out as a guest? Your confirmation email has a direct tracking link.';
  }
  var orders = CUSTOMER_DATA.orders || [];
  if(!orders.length){
    return 'You&rsquo;re signed in' + (CUSTOMER_DATA.first_name ? ', ' + esc(CUSTOMER_DATA.first_name) : '') + ', but I don&rsquo;t see any orders on this account yet.';
  }
  var labels = {fulfilled:'Shipped', partial:'Partially shipped', unfulfilled:'Processing', restocked:'Restocked', complete:'Complete'};
  var rows = orders.slice(0, 3).map(function(o){
    var statusLabel = o.cancelled ? 'Cancelled' : (labels[o.status] || esc(o.status) || 'Processing');
    return '<div class="c-order"><strong>' + esc(o.name) + '</strong> &middot; ' + esc(o.date) +
      '<br>Status: ' + statusLabel +
      (o.items ? '<div class="c-order-items">' + esc(o.items) + '</div>' : '') +
      (o.status_url ? '<a href="' + esc(o.status_url) + '" target="_blank" rel="noopener">Track this order &rarr;</a>' : '') +
      '</div>';
  }).join('');
  return 'Here&rsquo;s your recent order' + (orders.length > 1 ? 's' : '') + ':' + rows;
}
function cFallbackReply(){
  return 'I couldn&rsquo;t find a specific match for that &mdash; try browsing our <a href="/collections/all">full collection</a>, or email shop@aleadingrole.com and our team will help track it down.';
}
function cProductSearchReply(qs, cb){
  var term = qs
    .replace(/^(do (?:you|we) have|does (?:the store|this store|you) (?:carry|sell|stock)|do (?:you|we) (?:carry|sell|stock)|is there|are there|looking for|i want|i need|can i get|could i get|can you get|what about|where can i find|show me|got any|have any|any)\b/i, '')
    .replace(/[?!.]+$/, '')
    .trim();
  if(!term){ cb(cFallbackReply()); return; }
  fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last')
    .then(function(r){ return r.json(); })
    .then(function(data){
      var results = (data.resources && data.resources.results) || {};
      var products = results.products || [];
      var collections = results.collections || [];
      if(!products.length && !collections.length){ cb(cFallbackReply()); return; }
      var html = '';
      if(products.length){
        html += 'Here&rsquo;s what I found in the collection:' + products.map(function(p){
          var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
          return '<a class="c-prod" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '') +
            '<span>' + esc(p.title) + (p.price ? ' &mdash; $' + esc(p.price) : '') + '</span></a>';
        }).join('');
      }
      if(collections.length){
        html += (products.length ? '<div style="margin-top:8px;">Related collections:</div>' : 'Here&rsquo;s a collection that matches:') +
          collections.map(function(c){
            return '<a class="c-prod" href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span></a>';
          }).join('');
      }
      cb(html);
    })
    .catch(function(){ cb(cFallbackReply()); });
}
/* ---- concierge knowledge base ----
   Product facts and policy numbers come from /pages/concierge-kb, a Liquid
   JSON feed off the live catalogue (templates/page.concierge-kb.liquid).
   Product answers read the custom.* metafields, so editing a product in admin
   changes what the Concierge says with no theme deploy, and the returns copy
   below can never drift from /pages/returns the way the old hardcoded strings
   did. Fetched once per tab, cached in sessionStorage; every reply that uses
   it still has a hardcoded fallback for when the fetch fails. */
var CONCIERGE_KB = null;
var CONCIERGE_KB_KEY = 'alr_concierge_kb';
function cKB(cb){
  if(CONCIERGE_KB){ cb(CONCIERGE_KB); return; }
  try{
    var cached = sessionStorage.getItem(CONCIERGE_KB_KEY);
    if(cached){ CONCIERGE_KB = JSON.parse(cached); cb(CONCIERGE_KB); return; }
  }catch(err){}
  function kbPage(n){
    return fetch('/pages/concierge-kb?page=' + n, { credentials: 'same-origin' })
      .then(function(r){ return r.json(); });
  }
  kbPage(1).then(function(first){
    if(!first || !first.products) throw new Error('bad kb');
    var pages = parseInt(first.pages, 10) || 1;
    if(pages < 2) return first;
    /* Shopify caps paginate at 50 per page; pull the rest and merge so the
       Concierge sees the whole catalogue, not just the first 50 titles. */
    var rest = [];
    for(var n = 2; n <= pages; n++){ rest.push(kbPage(n)); }
    return Promise.all(rest).then(function(others){
      others.forEach(function(o){
        if(o && o.products && o.products.length){
          first.products = first.products.concat(o.products);
        }
      });
      return first;
    });
  }).then(function(data){
    CONCIERGE_KB = data;
    try{ sessionStorage.setItem(CONCIERGE_KB_KEY, JSON.stringify(data)); }catch(err){}
    cb(data);
  }).catch(function(){ cb(null); });
}
var C_STOPWORDS = /^(the|and|for|you|your|our|does|did|come|comes|with|what|whats|this|that|have|has|had|are|was|its|it|a|an|of|in|on|to|do|is|my|me|i|can|will|would|there|any|about|tell|know|need|want|get|see|buy|size|sizes|sizing|fit|fits|include|includes|included|including|box|package|packaged|costume|costumes|outfit|fabric|material|wash|washing|care|made|price|cost|much|item|items|one|does)$/;
function cTerms(qs){
  return qs.toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(function(w){
    return w.length > 2 && !C_STOPWORDS.test(w);
  });
}
/* Score each catalogue title by how many of the asker's meaningful words it
   contains. A single weak word match is usually a coincidence, so require two
   unless the question only had one word to go on. */
function cFindProduct(kb, qs){
  if(!kb || !kb.products || !kb.products.length) return null;
  var terms = cTerms(qs);
  if(!terms.length) return null;
  var best = null, bestScore = 0;
  kb.products.forEach(function(p){
    var hay = (p.t || '').toLowerCase();
    var score = 0;
    terms.forEach(function(w){ if(hay.indexOf(w) !== -1) score++; });
    if(score === 0) return;
    /* On a tie, the shorter title is the more specific match: "Ladybug Child
       Dress Up" beats "Ladybug 10th Anniversary Child Dress Up" when the only
       word the asker gave was "ladybug". */
    if(score > bestScore || (score === bestScore && best && p.t.length < best.t.length)){
      bestScore = score; best = p;
    }
  });
  return bestScore > 0 ? best : null;
}
function cProductCard(p, lines){
  var html = '<div class="c-order"><strong>' + esc(p.t) + '</strong>';
  lines.forEach(function(l){ if(l) html += '<br>' + esc(l); });
  if(p.avail === false) html += '<br><em>Currently sold out.</em>';
  html += '</div><a class="c-prod" href="' + esc(p.u) + '">' +
    (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '') +
    '<span>' + esc(p.t) + (p.price ? ' &mdash; ' + esc(p.price) : '') + '</span></a>';
  return html;
}
function cReturnsReply(cb){
  cKB(function(kb){
    var r = (kb && kb.returns) || null;
    var url = (r && r.url) || '/pages/start-a-return';
    var html = 'You can start a return yourself &mdash; no email, no waiting for approval. ' +
      '<a href="' + esc(url) + '"><strong>Open the returns portal &rarr;</strong></a><br><br>';
    if(r){
      html += 'You have ' + esc(String(r.window_days)) + ' days from purchase, on items that are ' + esc(r.condition) + '. Three ways to resolve it:';
      html += '<div class="c-order">';
      (r.options || []).forEach(function(o, i){
        html += (i ? '<br><br>' : '') + '<strong>' + esc(o.name) + '</strong><br>' + esc(o.detail);
      });
      html += '</div>';
      if(r.no_fee_cases) html += esc(r.no_fee_cases);
    } else {
      html += 'You have 30 days from purchase, on items that are unworn, unwashed and with tags attached. ' +
        'An exchange for a different size is free both ways. Store credit waives the 15% restocking fee and we cover the return label. ' +
        'A refund to your original payment is less the 15% fee, with return postage at your own cost.';
    }
    cb(html);
  });
}
function cIncludesReply(qs, cb){
  cKB(function(kb){
    var p = cFindProduct(kb, qs);
    if(p && (p.inc || p.size || p.care)){
      cb(cProductCard(p, [p.inc, p.size, p.care]));
      return;
    }
    if(p){
      cb(cProductCard(p, []) + '<br>I don&rsquo;t have a piece-by-piece list on file for that one yet &mdash; the product page photos show everything in the set, or email ' +
         'shop@aleadingrole.com and we&rsquo;ll confirm it for you.');
      return;
    }
    cb('Tell me which piece you mean and I&rsquo;ll list exactly what comes in the package. You can also check &ldquo;What&rsquo;s included&rdquo; on any product page.');
  });
}
function cSizingReply(qs, cb){
  cKB(function(kb){
    var p = cFindProduct(kb, qs);
    if(p && p.size){ cb(cProductCard(p, [p.size, p.inc])); return; }
    var sz = (kb && kb.sizing) || null;
    var summary = (sz && sz.summary) ||
      'Children&rsquo;s dress up runs from 3T up to 12/14 depending on the style, and premium adult pieces run 2XS&ndash;3XL. Between sizes, we suggest sizing up.';
    cb(esc(summary) + ' <a href="' + esc((sz && sz.url) || '/pages/sizing-chart') + '">See the full size chart &rarr;</a>' +
       '<br><br>Name a specific piece and I&rsquo;ll give you its exact range.');
  });
}
function cShippingReply(cb){
  cKB(function(kb){
    var sh = (kb && kb.shipping) || null;
    if(!sh){ cb('Orders ship within 1&ndash;3 business days &mdash; standard US delivery takes 3&ndash;7 business days, and orders over $99 ship free. &#10022;'); return; }
    cb(esc(sh.processing) + ' ' + esc(sh.domestic) +
       (sh.free_threshold ? ' Orders over $' + esc(String(sh.free_threshold)) + ' ship free. &#10022;' : ' &#10022;'));
  });
}
function cReply(qs, cb){
  var s = qs.toLowerCase();
  if(/^(hi|hey|hello|yo)\b|^hi$/.test(s.trim())){ cb('Hello! Welcome to A Leading Role. Ask me about sizing, shipping, returns, order tracking, or any piece in the collection.'); return; }
  if(/return|refund|exchange|send (it|this|them) back|money back|wrong size/.test(s)){ cReturnsReply(cb); return; }
  if(/track|tracking|order status|status of my order|where.*(my )?order|has my order|when will my order/.test(s)){ cb(cOrderReply()); return; }
  if(/what('?s| is| does).*(come|include|inside|in the (box|package|set))|include[ds]?\b|comes? with|come[s]? in the|what do i get|how many pieces|accessories/.test(s)){ cIncludesReply(qs, cb); return; }
  if(/size|sizing|fit|measurement|how big|age range|runs (small|large|big)/.test(s)){ cSizingReply(qs, cb); return; }
  if(/ship|deliver|arrive|how long|when will it/.test(s)){ cShippingReply(cb); return; }
  if(/fabric|material|wash|care|dry clean|machine wash|polyester|cotton/.test(s)){
    cKB(function(kb){
      var p = cFindProduct(kb, qs);
      if(p && p.care){ cb(cProductCard(p, [p.care, p.inc])); return; }
      cb('Fabric and care are listed on each product page under &ldquo;Fabric &amp; care&rdquo;. Tell me which piece you&rsquo;re asking about and I&rsquo;ll read it out &mdash; or email shop@aleadingrole.com and we&rsquo;ll confirm.');
    });
    return;
  }
  cProductSearchReply(qs, cb);
}
document.addEventListener('submit', function(e){
  if(e.target && e.target.matches && e.target.matches('#pd-form')){
    e.preventDefault();
    var vEl = document.getElementById('pd-variant-id');
    var qEl = document.getElementById('pd-qty');
    var variantId = vEl ? parseInt(vEl.value, 10) : null;
    var qty = qEl ? parseInt(qEl.value, 10) : 1;
    var btn = document.getElementById('pd-add');
    if(!variantId || (btn && btn.disabled)) return;
    var btnLabel = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    addVariant(variantId, qty || 1).then(function(){
      if(btn){ btn.disabled = false; btn.textContent = btnLabel || 'Add to Bag'; }
    });
    return;
  }
  if(e.target && e.target.matches && e.target.matches('#c-form')){
    e.preventDefault();
    var inp = document.getElementById('c-input');
    var v = inp.value.trim(); if(!v) return;
    cMsg(v.replace(/</g,'&lt;'), 'me'); inp.value = ''; cSaveDraft('');
    setTimeout(function(){ cReply(v, function(answer){ cMsg(answer); }); }, 600);
  }
});
/* ---- live search ---- */
var msearchTimer = null;
function renderMSearch(term){
  var countEl = document.getElementById('msearch-count');
  var resultsEl = document.getElementById('msearch-results');
  if(!countEl || !resultsEl) return;
  if(!term){ countEl.textContent = 'Start typing and press enter'; resultsEl.innerHTML = ''; return; }
  countEl.textContent = 'Searching…';
  fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
    .then(function(r){ return r.json(); })
    .then(function(data){
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if(!products.length){
        countEl.textContent = 'No pieces found for “' + term + '”';
        resultsEl.innerHTML = '';
        return;
      }
      countEl.textContent = products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for “' + term + '”';
      resultsEl.innerHTML = products.map(function(p){
        var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
        var qaddBtn = (p.available !== false && p.handle)
          ? '<button type="button" class="qadd" aria-label="Quick add to bag" title="Quick add" data-search-handle="' + esc(p.handle) + '">+</button>'
          : '';
        var wlBtn = p.handle
          ? '<button type="button" class="wlbtn" aria-label="Save to wishlist" aria-pressed="false" title="Save to wishlist" data-wl="' + esc(p.handle) + '"><svg viewBox="0 0 24 24" stroke-width="1.8"><path d="M12 20.5s-7.5-4.6-9.7-9.1C.7 8 2.1 4.5 5.5 3.7c2.1-.5 4 .4 6.5 3 2.5-2.6 4.4-3.5 6.5-3 3.4.8 4.8 4.3 3.2 7.7-2.2 4.5-9.7 9.1-9.7 9.1z"/></svg></button>'
          : '';
        return '<a class="prod-card" href="' + p.url + '">' +
          '<div class="prod-thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + qaddBtn + wlBtn + '</div>' +
          '<div class="prod-name">' + p.title + '</div>' +
          '<div class="prod-price">' + (p.price ? '$' + p.price : '') + '</div>' +
          '</a>';
      }).join('');
      syncWishlistUI();
    })
    .catch(function(){ countEl.textContent = 'Search is unavailable right now — press enter to see full results.'; });
}
document.addEventListener('input', function(e){
  if(e.target && e.target.id === 'msearch-input'){
    var term = e.target.value.trim();
    clearTimeout(msearchTimer);
    msearchTimer = setTimeout(function(){ renderMSearch(term); }, 300);
  }
});
/* ---- scroll + boot ---- */
window.addEventListener('scroll', function(){
  var b = document.getElementById('back-top');
  if(b) b.classList.toggle('show', window.scrollY > 500);
}, {passive:true});
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape') closeMobileNav();
});
window.addEventListener('resize', function(){
  if(window.innerWidth > 960) closeMobileNav();
});
function initRecommendations(){
  var el = document.querySelector('.you-may-also-like[data-url]');
  if(!el) return;
  fetch(el.getAttribute('data-url'))
    .then(function(r){ return r.text(); })
    .then(function(text){
      var html = document.createElement('div');
      html.innerHTML = text;
      var fresh = html.querySelector('.you-may-also-like');
      if(fresh && fresh.innerHTML.trim().length){ el.innerHTML = fresh.innerHTML; }
    })
    .catch(function(){ /* leave empty on failure */ });
}
document.addEventListener('DOMContentLoaded', function(){
  pdMarkSoldOutOptions();
  pdSyncVariant();
  initRecommendations();
  syncWishlistUI();
  var wf = document.getElementById('w-form');
  if(wf) wf.addEventListener('submit', function(){
    try{ localStorage.setItem('alr_welcome_subscribed','1'); }catch(err){}
  });
  if(window.__alrAccountModalOpen){
    var am = document.getElementById('modal-account');
    if(am){
      if(window.__alrAccountModalOpen === 'login'){
        document.getElementById('account-register-view').style.display = 'none';
        document.getElementById('account-login-view').style.display = '';
        am.querySelector('.p-head h2').textContent = 'Sign In';
      }
      lockScroll();
      am.showModal();
    }
    return;
  }
  var justReturnedFromLogin = false;
  try{ justReturnedFromLogin = sessionStorage.getItem('alr_pending_login_return') === '1'; }catch(e){}
  if(justReturnedFromLogin){
    try{ sessionStorage.removeItem('alr_pending_login_return'); }catch(e){}
  }
  var conciergeWasOpen = cWasLeftOpen();
  var subscribed = null, dismissedAt = null, shown = null;
  try{
    subscribed = localStorage.getItem('alr_welcome_subscribed');
    dismissedAt = parseInt(localStorage.getItem('alr_welcome_dismissed_at'), 10);
    shown = sessionStorage.getItem('alr_welcome_shown');
  }catch(e){}
  var cooldownActive = dismissedAt && !isNaN(dismissedAt) && (Date.now() - dismissedAt) < WELCOME_DISMISS_COOLDOWN_MS;
  var w = document.getElementById('modal-welcome');
  var welcomeWillShow = !!(w && !subscribed && !cooldownActive && !shown && !justReturnedFromLogin && !conciergeWasOpen);
  if(welcomeWillShow){
    setTimeout(function(){
      if(!document.querySelector('dialog[open]')){
        try{ sessionStorage.setItem('alr_welcome_shown','1'); }catch(e){}
        lockScroll();
        w.showModal();
      }
    }, 1600);
  }
  function maybeAutoOpenConcierge(){
    var today = new Date().toISOString().slice(0, 10);
    var last = null;
    try{ last = localStorage.getItem('alr_concierge_shown_date'); }catch(e){}
    if(last === today) return;
    if(document.querySelector('dialog[open]')) return;
    var c = document.getElementById('concierge');
    if(!c || c.classList.contains('open')) return;
    try{ localStorage.setItem('alr_concierge_shown_date', today); }catch(e){}
    openConciergePanel();
  }
  if(conciergeWasOpen){
    openConciergePanel();
  } else if(justReturnedFromLogin && CUSTOMER_DATA.logged_in){
    setTimeout(function(){
      if(!document.querySelector('dialog[open]')){
        var today2 = new Date().toISOString().slice(0, 10);
        try{ localStorage.setItem('alr_concierge_shown_date', today2); }catch(e){}
        openConciergePanel();
      }
    }, 700);
  } else if(welcomeWillShow){
    w.addEventListener('close', function(){ setTimeout(maybeAutoOpenConcierge, 400); }, {once:true});
  } else {
    setTimeout(maybeAutoOpenConcierge, 1600);
  }
});
})();
